import { useState, Fragment, useContext } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import {
  RadioButton,
  CheckboxField,
  Badge,
  Input,
  Button,
  notificationConnect,
} from '@livechat/design-system'

import { Context } from '../context'
import api from '../api'
import MarkdownRenderer from './MarkdownRenderer'

const formatNotification = (
  content,
  variant = 'error',
  autoHideDelayTime = 4000,
  removable = true,
  horizontalPosition = 'center',
  verticalPosition = 'top'
) => ({
  type: 'toast',
  autoHideDelayTime,
  payload: {
    variant,
    content,
    horizontalPosition,
    verticalPosition,
    removable,
  },
})

const inputCss = css`
  width: 100%;
`

const SurveyQuestion = ({
  item,
  index,
  isEditOpen,
  surveyId,
  notificationSystem,
}) => {
  const { surveyToken, editSurveyQuestion } = useContext(Context)

  const [editingQuestion, setEditingQuestion] = useState(item.question)
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const isDirty = editingQuestion !== item.question

  const onSubmit = async () => {
    if (editingQuestion) {
      setIsLoading(true)
      try {
        await api.editSurveyQuestion(
          surveyToken,
          surveyId,
          item.id,
          editingQuestion
        )
        editSurveyQuestion(surveyId, item.id, editingQuestion)
        notificationSystem.add(
          formatNotification('Survey question updated successfully!', 'success')
        )
      } catch (err) {
        notificationSystem.add(formatNotification(error.message))
        console.log(err)
      }
      setIsLoading()
      setError()
    } else {
      setError('Question cannot be empty')
    }
  }

  return (
    <div className="field" key={index}>
      <div className="question">
        {isEditOpen ? (
          <Fragment>
            <Input
              error={error}
              css={inputCss}
              value={editingQuestion}
              onChange={(e) => setEditingQuestion(e.target.value)}
            />
            <Button
              disabled={!isDirty}
              type="ghost"
              onClick={onSubmit}
              loading={isLoading}
              css={css`
                margin-left: 15px;
                min-width: 80px;
              `}
            >
              Save
            </Button>
          </Fragment>
        ) : (
          <Fragment>
            <Badge>{index + 1}</Badge>
            <MarkdownRenderer>{item.question}</MarkdownRenderer>
          </Fragment>
        )}
      </div>

      <div className="content">
        {item.answers && !!item.answers.length && (
          <div className="answers">
            {item.answers.map((answer, index) => (
              <div className="answer" key={`answer-${index}`}>
                {item.type === 'SINGLE_CHOICE' && (
                  <RadioButton checked={false}>{answer}</RadioButton>
                )}
                {item.type === 'MULTI_CHOICE' && (
                  <CheckboxField checked={false}>{answer}</CheckboxField>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="details">
        <span className="badge">
          {item.type === 'TEXT_ANSWER' && 'text answer'}
          {item.type === 'SINGLE_CHOICE' && 'single choice answer'}
          {item.type === 'MULTI_CHOICE' && 'multi choice answer'}
          {item.type === 'SCORE' && 'score answer'}
        </span>
        {item.type === 'SCORE' && (
          <span className="badge">
            from {item.score?.range?.min} to {item.score?.range?.max}
          </span>
        )}
        <span className="badge">
          {item.required ? 'required' : 'not required'}
        </span>
      </div>
    </div>
  )
}

export default notificationConnect(SurveyQuestion)
